import { useMediaQuery } from '../../tools/hooks/useMediaQuery';

const useBreakPoints = () => {
  const isMobile = useMediaQuery('(max-width: 576px)');

  return { isMobile };
};

export default useBreakPoints;
